<template>
  <div style="padding: 10px; margin: 0">
    <view-table
        v-if="isShow"
        ref="viewTable"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        :url="url"
        @select="selectHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button type="primary" :loading="saveLoading" @click="batchSave"> 批量保存</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
          <el-form-item label="客户名称">
            <el-select v-model="filter.customerId" filterable placeholder="请选择" @change="urlChange">
              <el-option
                  v-for="item in customerList"
                  :key="item.customerId"
                  :label="item.customerName"
                  :value="item.customerId"/>
            </el-select>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.strPurchaseOrderNoes" placeholder="请输入采购单号"/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" placeholder="请选择状态">
              <el-option :value="-1" label="全部"/>
              <el-option :value="0" label="未确认"/>
              <el-option :value="5" label="已确认"/>
            </el-select>
          </el-form-item>
          <el-form-item style="width:180px"/>
          <el-form-item label="下单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'beginCreateTime', 'endCreateTime')"/>
          </el-form-item>
          <el-form-item label="交货日期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'beginDeliveryDate', 'endDeliveryDate')"/>
          </el-form-item>
          <el-form-item label="采购">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入"/>
          </el-form-item>
        </el-form>
      </template>
      <el-table-column type="selection" align="center" width="55" prop="selection"/>
      <el-table-column
          type="index"
          width="55"
          align="center"
          label="#"
          prop="index"/>
      <el-table-column align="center" prop="purchaseOrderNo" label="采购单号" min-width="120">
        <template slot-scope="scope">
          <span
              style="cursor: pointer; color: #2d8cf0"
              @click="$refs.customerPurchaseOrderPreview.open(scope.row, filter.customerId)">
            {{scope.row.purchaseOrderNo}}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="salesOrderNo" label="销售单号" min-width="120"/>
      <el-table-column align="center" prop="projectType" min-width="120" label="项目类型"/>
      <el-table-column align="left" prop="projectName" label="项目信息" show-overflow-tooltip/>
      <el-table-column align="center" prop="statusName" label="状态" min-width="90"/>
      <el-table-column align="center" prop="deliveryDate" label="交货日期" min-width="90">
        <template slot-scope="scope">
          <span>
            {{$moment(scope.row.deliveryDate).format("YYYY-MM-DD")}}
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间" min-width="150"/>
      <el-table-column align="center" prop="updateTime" label="修改时间" min-width="150"/>
    </view-table>

    <customer-purchase-order-preview ref="customerPurchaseOrderPreview" @save-success="loadData()"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import CustomerPurchaseOrderPreview from "./CustomerPurchaseOrderPreview";

  export default {
    name: "CustomerPurchaseOrderList",
    components: {
      ViewTable,
      CustomerPurchaseOrderPreview,
    },
    data() {
      return {
        isShow: false,
        url: "",
        deliveryDateRange: [],
        createDateRange: [],
        filter: {
          customerId: "",
          status: 0,
          beginDeliveryDate: "",
          endDeliveryDate: "",
          strPurchaseOrderNoes: "",
          customerNo: "",
          beginCreateTime: "",
          endCreateTime: "",
          buyUserName:"",
        },
        columnsProperty: [
          {
            key: "purchaseOrderNo",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.customerPurchaseOrderPreview.open(params.row, this.filter.customerId);
                    },
                  },
                },
                params.row.purchaseOrderNo,
              );
            },
          },
          {
            key: "salesOrderNo",
            align: "center",
          },
          {
            key: "projectType",
            align: "center",
          },
          {
            key: "projectName",
            align: "center",
          },
          {
            key: "statusName",
            align: "center",
            width: 80,
          },
          {
            key: "deliveryDate",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                "span",
                params.row.deliveryDate ? params.row.deliveryDate.substring(0, 10) : "",
              );
            },
          },
          {
            key: "createTime",
            align: "center",
            width: 160,
          },
          {
            key: "updateTime",
            align: "center",
            width: 160,
          },
        ],
        customerList: [],
        saveLoading: false,
        selection: [],
      };
    },
    watch: {
      "filter.beginCreateTime": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.beginCreateTime);
            this.createDateRange.push(this.filter.endCreateTime);
          }
        },
      },
      "filter.beginDeliveryDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.beginDeliveryDate);
            this.deliveryDateRange.push(this.filter.endDeliveryDate);
          }
        },
      },
    },
    created() {
      this.getCustomerList();
    },

    methods: {
      // 根据客户id查询数据
      loadData() {
        this.$refs.viewTable.loadData(1);
      },

      // 获取客户列表
      getCustomerList() {
        this.$http.get("basic", "customerDevelopers/getAllList").then((resp) => {
          if (resp.success) {
            this.customerList = resp.data;
            this.filter.customerId = resp.data[0].customerId;
            this.url = "crm/po/list/page/" + resp.data[0].customerId;
            this.isShow = true;
          }
        });
      },

      selectHandle(selection) {
        this.selection = selection;
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 批量保存
      batchSave() {
        const arr = this.selection.filter((item) => item.statusName !== "未确认");
        if (!this.selection.length) {
          this.$confirm("请选择需要保存的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else if (arr.length) {
          this.$confirm("请选择未确认的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.saveLoading = true;
          let ids = [];
          this.selection.forEach((item) => {
            ids.push(item.purchaseOrderNo);
          });
          const params = {
            customerId: this.filter.customerId,
            purchaseOrderNoes: ids,
          };
          console.log(params);
          this.$http
            .post("basic", "crm/po/confirm/", params)
            .then((res) => {
              if (res.success) {
                this.$message.success("保存成功");
              }
              this.saveLoading = false;
            })
            .catch(() => {
              this.saveLoading = false;
            });
        }
      },
      urlChange() {
        if (this.filter.customerId) {
          this.url = "crm/po/list/page/" + this.filter.customerId;
        }
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
